import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import AssignPreference from '../../components/activity-assign-preference';
import {
    getActivityAssignPreferences,
    saveActivityAssignPreferences,
    resetPreferences
} from './actions';

class ActivityAssignPreference extends Component {
    static propTypes = {
        getActivityAssignPreferences: PropTypes.func,
        saveActivityAssignPreferences: PropTypes.func,
        resetPreferences: PropTypes.func
    }

    componentDidMount() {
        this.props.getActivityAssignPreferences();
    }

    savePreference = (request) => {
        this.props.saveActivityAssignPreferences(request);
    }

    resetPreference = (request) => {
        this.props.resetPreferences(request);
    }

    render() {
        return (
            <div>
                <AssignPreference
                    resetPreference={this.resetPreference}
                    saveActivityAssignPreferences={this.savePreference}
                    {...this.props} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        activityAssignPreferences: state.activityAssignPreference.activityAssignPreferences,
        isSaveInProgress: state.activityAssignPreference.isSaveInProgress,
        isDataLoaded: state.activityAssignPreference.isDataLoaded
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getActivityAssignPreferences,
        saveActivityAssignPreferences,
        resetPreferences
    }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ActivityAssignPreference));



// WEBPACK FOOTER //
// ./app/containers/activity-assign-preference/index.js